module.exports = __webpack_public_path__ + "img/taobao-circle.f5c3ec69.svg";